import React, { useState } from 'react';
import { Container } from "react-bootstrap";
import classes from '../pages.module.css';
import TextCol from '../../components/Ui/text/textCol';
import BtnDownload from '../../components/Ui/button/btnDownload';
import agregator from '../../image/modules/aggregator1.png';
import ModuleItem from '../../components/Ui/block/moduleItem';

const LmWDM = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Конвергенция всего трафика через OTN, включая низкоскоростные сервисы'},
        {id:2, content: 'Не имитация SDH, а настоящий E1oOTN'},
        {id:3, content: 'Полная совместимость с существующим оборудованием'},
        {id:4, content: 'Полный вывод из эксплуатации любого оборудования SDH / PDH'},
        {id:5, content: 'Не влияет на CPE или SLA клиента'},
        {id:6, content: 'Полная инфраструктура OTN / WDM с огромным увеличением емкости, минимальной задержкой и сохранением синхронизации'},
    ])
    const [lists, setlists] = useState ([
        {id:1, list: '8 канальный MUX/DEMUX (with upgrade port)'},
        {id:2, list: '8 канальный MUX/DEMUX (without upgrade port)'},
        {id:3, list: '2 канальный OADM'},
        {id:4, list: 'Полностью пассивное решение'},
        {id:5, list: 'Единый сетевой элемент с LM-1 OTN и/или Micro OTN'},
        {id:6, list: 'Типичный сценарий 30 км / 5 узлов / 8 каналов'},
    ])
    const [lists1, setlists1] = useState ([
        {id:1, list: '16 канальный MUX/DEMUX'},
        {id:2, list: '2 канальный OADM'},
        {id:3, list: '4 канальный OADM'},
        {id:4, list: 'Единый сетевой элемент с LM-1 OTN и/или Micro OTN'},
        {id:5, list: 'Типичный сценарий 60 км / 6 узлов / 16 каналов'},
    ])
    return(
        <>
           <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>оборудование для оптических сетей</span>
                        <h1>LM-1 WDM</h1>
                        <p>Платформа LM-1 WDM помогает дополнить решение LM1 OTN или LM1 micro OTN технологиями CWDM или DWDM для сетей Metro или доступа. Решение с поддержкой до 16 каналов оптимально для городской сети доступа. Может дополняться платформой LM-1 microROADM, предлагающей также активные и полностью реконфигурируемые приложения DWDM.</p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <BtnDownload title="Скачать спецификацию" url='/src/download/test.txt' />
            <ModuleItem item={{
                class: 'moduleItem1',
                title: 'Варианты CWDM',
                src: (agregator),

            }}
                lists={lists}
            />
            <ModuleItem item={{
                class: 'moduleItem2',
                title: 'Варианты DWDM',
                src: (agregator),

            }}
                lists={lists1}
            />
        </>
    )
}

export default LmWDM;